import InfiniteScroll from '../../NUI/InfiniteScroll';

const IcosmPartners = () => {
    const img_path= "https://storage.googleapis.com/icosm/2/";

    const partners = ["alma", "athena-biomed", "cx", "evolus", "hyperion", "qt", "tr", "avaderm", "medical-aesthetic", "xytide", "teoxane", "rejuran", "merz", "hugel", "galderma", "dermocosmetica", "cryomed", "allergan", "inskin","team-medical"];
    const images = partners.map(n => ({img: `${img_path}partners-${n}.png`}));

    return  <div fluid className="!py-0 md:h-[205px] w-full overflow-hidden flex items-center">
                <InfiniteScroll images={images} duration={90} imgCls="shrink-0 max-w-[28vw] md:max-w-[228px] rounded" />
            </div>
}

export default IcosmPartners;
